<template>
  <v-dialog v-model="dialog">
    <v-toolbar dense color="primary" dark>
      <v-toolbar-title>
        {{ $t('fields.global.downloadMatch') }}
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-btn dark icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-container>
          <v-flex>
            <h3 class="text-center">
              {{ $t('titles.matches.downloadMatch.caution.title') }}
            </h3>
            <ol>
              <li v-for="i in 3" :key="i" class="body-1">
                {{ $t(`titles.matches.downloadMatch.caution.content${i}`) }}
              </li>
            </ol>
            <h3 class="text-center">
              {{ $t('titles.matches.downloadMatch.agree.title') }}
            </h3>
            <ol>
              <li v-for="i in 4" :key="i" class="body-1">
                {{ $t(`titles.matches.downloadMatch.agree.content${i}`) }}
              </li>
            </ol>
            <h3 class="text-center">
              {{ $t('titles.matches.downloadMatch.caveat.title') }}
            </h3>
            <ol>
              <li v-for="i in 2" :key="i" class="body-1">
                {{ $t(`titles.matches.downloadMatch.caveat.content${i}`) }}
              </li>
            </ol>
            <h3 class="text-center">
              {{ $t('titles.matches.downloadMatch.howWork.title') }}
            </h3>
            <ol>
              <li v-for="i in 4" :key="i" class="body-1">
                {{ $t(`titles.matches.downloadMatch.howWork.content${i}`) }}
              </li>
            </ol>
          </v-flex>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          download
          small
          color="success"
          target="_blank"
          :href="video.src"
          @click="updateMatch"
        >
          {{ $t('fields.global.downloadMatch') }}
        </v-btn>
        <v-btn small color="error" @click="cancel">
          {{ $t('action.buttons.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    dialog: {
      type: Boolean,
    },
    video: {
      type: Object,
    },
    id: {
      type: String,
    },
  },
  methods: {
    ...mapActions({
      update: 'matches/updateMatch',
    }),
    cancel() {
      this.$emit('close')
    },
    updateMatch() {
      const match = {
        _id: this.id,
        type: 'download',
      }
      this.update(match)
    },
  },
}
</script>

<style></style>
